import { http } from '../../../shared/services/http.service';
import type { PendingCount } from '../models/shell.model';

export const shellService = {
  pendingCount: (ledgerId: string): Promise<PendingCount> =>
    http.get(`/api/ledgers/${ledgerId}/pending-count`),
};
